import {
  AppClientListEntry,
  AppClientListLicenceStatus
} from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { ListFieldInfo } from '../../../common/list/list-types';

export const AppClientListView: ListFieldInfo<AppClientListEntry, undefined>[] = [
  {
    name: 'logoUrl',
    label: 'Logo',
    kind: 'img',
    displayed: true,
    visibleAfterSm: true
  },
  {
    name: 'name',
    label: 'Name',
    kind: 'link',
    displayed: true,
    sortable: true
  },
  {
    name: 'domainName',
    label: 'Domain Name',
    kind: 'text',
    displayed: true,
    sortable: true
  },
  {
    // TODO: Misnamed in AppClientListEntry, should be called recommendationsVisible
    name: 'recommendations',
    label: 'Recommendations',
    kind: 'checkItem',
    displayed: true,
    align: 'centre',
    visibleAfterSm: true
  },
  {
    name: 'walkthroughsEnabled',
    label: 'Walkthroughs Enabled',
    kind: 'checkItem',
    displayed: true,
    align: 'centre',
    visibleAfterSm: true
  },
  {
    name: 'licence',
    label: 'Licence',
    kind: 'mapped',
    displayed: true,
    sortable: false,
    map: entry => (entry.licence === AppClientListLicenceStatus.active ? 'active' : 'no licence'),
    align: 'centre'
  },
  {
    name: 'licenceStart',
    label: 'Start',
    kind: 'instant',
    displayed: true,
    sortable: true,
    align: 'centre',
    visibleAfterSm: true
  },
  {
    name: 'licenceEnd',
    label: 'End',
    kind: 'instant',
    displayed: true,
    sortable: true,
    align: 'centre'
  },
  {
    name: 'appClientLicence.userCounts',
    label: 'Users/Licensed Users',
    kind: 'mapped',
    displayed: true,
    sortable: false,
    map: entry => `${entry.totalActiveUsers}/${entry.licenceActiveUsers}`,
    align: 'centre'
  }
];



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/appclient-list/appclient-list-view.ts